import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import platform from 'platform';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import { ActionButton } from '../components/ActionButton';
import ActionLink from '../components/ActionLink';
import DivContainer from '../components/DivContainer';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import SimpleReactValidator from '../components/validator';
import ProfileService from '../services/ProfileService';


class TrustedDevicesDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new ProfileService());
        this.user = this.authService.getProfile();
        this.state = {
            currentDeviceAddedToTrusted: false,
            listToRemove: [],
            elementId: props.elementId,
            element: {
                trustedDeviceList: [],
            },
            viewMode: 'EDIT',
            cardLoading: false,
        };
        this.validator = new SimpleReactValidator({}, props.t);
        this.handleChange = this.handleChange.bind(this);
    }

    translate(key) {
        const { t } = this.props;
        return t(key);
    }

    prepareFooter() {
        const { t } = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton label={t('details.cancel')} variant={'button cancel-button white'} handleClick={this.props.onHide} />
                <ActionButton
                    label={t('details.saveChanges')}
                    variant='button save-button blue'
                    handleClick={this.handleFormSubmit}
                />
            </div>
        );
    }

    handleFormSubmit(event) {
        if (event)
            if (event !== undefined) {
                event.preventDefault();
            }
        if (this.validator.allValid()) {
            this.blockUi(this.handleValidForm);
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    renderHeader() {
        const { t } = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>{t('profile.changeTrustedDevices')}</label>
                </DivContainer>
            </DivContainer>
        );
    }

    updateElement(data) {
        let currentDeviceFromCookie = this.readCookieLocalStorage('trustedDeviceId');
        let addedCurrentDevice = data?.trustedDeviceList?.filter(el => el.deviceIdent === currentDeviceFromCookie).length > 0 ? true : false;
        this.setState(
            {
                addedCurrentDevice,
                element: {
                    trustedDeviceList: data.trustedDeviceList,
                    //  addCurrentDevice: addedCurrentDevice,
                },
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }
    setElement() {

        if (this.props.element) {

            this.updateElement(this.props.element);
        }
    }



    createOrUpdate() {
        const {t} = this.props;
        this.scrollToTop();
        if (this.state.addedCurrentDevice !== this.state.element.addCurrentDevice && this.state.element.addCurrentDevice === true) {
            let generatedDeviceUuid = this.authService.generateDeviceUuid();
            this.service
                .addTrustedDevice(generatedDeviceUuid, this.user?.userAgreementMapId)
                .then((res) => {
                    if (res === true) {
                        this.saveCookieLocalStorage('trustedDeviceId', generatedDeviceUuid);
                    };
                    this.showSuccessMessage(t('profile.successTrustedDeviceUpdate'));
                    if (this.props.afterSave) {
                        this.props.afterSave(res);
                    }
                }
                )
                .catch((err) => {
                    this.showErrorMessage(t('error.trustedDevicesError'))
                    this.unblockUi();
                })
        }
   
        if(this.state.listToRemove?.length >0){
            let listIds= this.state.listToRemove?.map(el => el.deviceIdent);
            this.service.editTrustedDevices(listIds, this.user?.userAgreementMapId)
            .then((res) => {
                if (res === true) {  }
                this.showSuccessMessage(t('profile.successTrustedDeviceUpdate'));
                if (this.props.afterSave) {
                    this.props.afterSave(res);
                }
            })
            .catch((err)=> {
                this.showErrorMessage(t('error.trustedDevicesError'))
                this.unblockUi();})
        }
        this.unblockUi();
        

    }

    handleAddElement(newElement) {
        const modifiedList = this.state.element.trustedDeviceList;
        modifiedList.push(newElement);
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                trustedDeviceList: modifiedList,
            },
        }));
    }
    handleRemove(e, id) {
        if (e) {
            e.preventDefault();
        }
        const modifiedList = this.state.element?.trustedDeviceList;
        const listToRemove = this.state.listToRemove;
        let elementToRemove;
        let index;
        modifiedList.forEach((element, i) => {
            if (element.deviceId === id) {
                elementToRemove = element;
                index = i;
            }
        });
        listToRemove.push(elementToRemove);
        modifiedList.splice(index, 1);
        this.setState((prevState) => ({
            listToRemove: listToRemove,
            element: {
                ...prevState.element,
                trustedDeviceList: modifiedList,
            },
        }));
    }



    renderDetails() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <div className='col'>
                    <label className='p-label' style={{ margin: '0px' }}>{this.state.element.trustedDeviceList?.length === 0 ? "Brak urządzeń zaufanych" : t('profile.deviceName')}</label>
                    {this.state.element?.trustedDeviceList.map((el, index) => {
                        return (
                            <div className='row'>


                                <InputTextComponent
                                    key={`deviceIdent-${index}`}
                                    id={`deviceIdent-${index}`}
                                    name='deviceIdent'
                                    label={t('profile.deviceName')}
                                    colClass='col-11'
                                    stateField={`element.trustedDeviceList[${index}]`}
                                    viewMode={'VIEW'}
                                    showLabel={false}
                                    onChange={this.handleChange}
                                    value={el.deviceIdent + " ("+ el.deviceName+ " )"}
                                    disabled
                                />

                                <div className='col-1 trash-input'>
                                    <ActionLink
                                        className='trash-input-button float-right'
                                        iconSvg='ico_trash_inputtext'
                                        iconSide='left'
                                        label=''
                                        handleClick={(e) =>
                                            this.handleRemove(e, el.deviceId)
                                        }
                                        id={`delete_person_${index}`}
                                        // rendered={index !== 0}
                                        title='Przycisk usunięcie pola'
                                    />
                                </div>
                            </div>
                        )
                    })}
                    <div className='row add-button-row'>
                        <div className='col-12 margin-top-8'>

                            {this.state.addedCurrentDevice === true ?
                                null :
                                <InputCheckboxComponent
                                    id={'addCurrentDevice'}
                                    name='addCurrentDevice'
                                    label={t('profile.addTrustedDevice')}
                                    stateField='element'
                                    labelOnRight
                                    value={this.state.element.addCurrentDevice}
                                    onChange={this.handleChange}
                                    viewMode={'EDIT'}
                                    labelClassName='p-label'
                                    colClass='col-width-auto'
                                />

                            }

                        </div>
                    </div>





                </div>

            </React.Fragment>
        );
    }
}

TrustedDevicesDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'EDIT',
    visible: false,
};

TrustedDevicesDialog.propTypes = {
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    handleSuccess: PropTypes.func,
    handleError: PropTypes.func,
    afterSave: PropTypes.func,
};

export default withTranslation()(TrustedDevicesDialog);
